<template>
  <div class="tw-rounded-sm tw-bg-white tw-pt-4 tw-h-full">
    <card-placeholder-banner
      type="EMAIL_SECURITY"
      :data-test-id="`${tier}-email-security-most-targeted-chart-banner`"
    >
      <template #title>{{ $t("most-targeted-users-title") }}</template>
      <template #text>
        {{ $t("dashboard-demo-email-security") }}
      </template>
    </card-placeholder-banner>
    <targeted-users-table
      :users="users"
      :data-test-id="`${tier}-email-security-most-targeted-chart`"
    />
  </div>
</template>

<script setup lang="ts">
import { TargetedUser } from "@/components/TargetedUsers/types/TargetedUsers";
import CardPlaceholderBanner from "../CardPlaceholderBanner/CardPlaceholderBanner.vue";
import TargetedUsersTable from "@/components/TargetedUsers/TargetedUsersTable.vue";
import { useIsMspRoute } from "@/composables/useIsMspRoute";

const { isMspRoute } = useIsMspRoute();

const tier = isMspRoute.value ? "msp" : "customer";
const users: TargetedUser[] = [
  {
    email: "john.doe@example.com",
    count: 45,
  },
  {
    email: "jane.smith@example.com",
    count: 23,
  },
  {
    email: "david.wilson@example.com",
    count: 15,
  },
  {
    email: "mary.brown@example.com",
    count: 11,
  },
  {
    email: "robert.jones@example.com",
    count: 4,
  },
];
</script>
